import React from 'react'
import { useStateValue } from "./StateProvider";
import CheckoutProduct from "./CheckoutProduct";
import "./Checkout.css"
import Subtotal from './Subtotal';

function Checkout() {

    const [{ basket, user }] = useStateValue();
    
    return (
        <div className="checkout">
            <div className="checkout-left">
                <img className="checkout-banner"
                    src="images/checkout-banner.jpg"
                />
            
            {basket?.length === 0 ? (
                <div>
                    <h2 className="checkout-title">Your basket is empty</h2>
                </div>
            ) : (
                <div>
                    <h3>{user?.email}</h3>
                    <h2>Your basket</h2>

                    {basket.map( item => (
                        <CheckoutProduct
                            id = {item.id}
                            title = {item.title}
                            image = {item.image}
                            price = {item.price}
                        />
                    ))}
                </div>

                
            )}
            </div>
            
            <div className="checkout-right">
                <Subtotal />
            </div>
            
        </div>
    );
}

export default Checkout
